module.exports = __webpack_public_path__ + "static/img/5.c49b1602.png";